export const mapDmProjectStatusToDealStatus = (status: string) => {
    switch (status) {
        case 'DRAFT':
            return 'Draft';
        case 'DEAL_ROOM_READY':
            return 'Deal Room Ready';
        case 'IN_DEAL_REVIEW':
            return 'In Deal Review';
        case 'UNDERWRITING_PASS':
            return 'Underwriting Pass';
        case 'UNDERWRITING_FAIL':
            return 'Underwriting Fail';
        default:
            return 'Draft';
    }
};

export const DEAL_REVIEW_STATUSES = [
    { value: 'DEAL_ROOM_READY', label: 'Deal Room Ready' },
    { value: 'IN_DEAL_REVIEW', label: 'In Deal Review' },
    { value: 'UNDERWRITING_PASS', label: 'Underwriting Pass' },
    { value: 'UNDERWRITING_FAIL', label: 'Underwriting Fail' },
];